var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
import { connect } from "react-redux";
import { FlexWrapperConsumer, FlexWrapperFocus, FlexWrapperProvider, flexWrapperBindingInit, } from "../../components/core/03-base/FlexWrapper";
import { ModalWrapperConsumer, ModalWrapperProvider, modalWrapperBindingInit, } from "../../components/core/06-molecules/ModalWrapper";
import { BreakpointConsumer, BreakpointProvider, breakpointBindingInit, } from "../Breakpoints";
import { ensure } from "../Optional";
import { maryInit, maryUnlink, maryUpdate } from "./ActionTypes";
import { State } from "./State";
/**
 *
 */
export var MaryProvider = function (props) { return (React.createElement(BreakpointProvider, null,
    React.createElement(ModalWrapperProvider, null,
        React.createElement(FlexWrapperProvider, { defaultFocus: props.flexDefaultFocus || FlexWrapperFocus.SIDEBAR, asWidget: props.asWidget },
            React.createElement(BreakpointConsumer, null, function (bc) { return (React.createElement(ModalWrapperConsumer, null, function (mwc) { return (React.createElement(FlexWrapperConsumer, null, function (fw) { return (React.createElement(MaryInitializer, { breakpoint: bc, modalWrapper: mwc, flexWrapper: fw }, props.children)); })); })); }))))); };
/**
 *
 */
export var maryStateInit = function () { return ({
    breakpoints: State.create(breakpointBindingInit),
    flex: State.create(flexWrapperBindingInit),
    modal: State.create(modalWrapperBindingInit),
}); };
/**
 *
 */
var MaryInitializerComp = /** @class */ (function (_super) {
    __extends(MaryInitializerComp, _super);
    /**
     *
     * @param props
     */
    function MaryInitializerComp(props) {
        return _super.call(this, props) || this;
    }
    /**
     *
     * @param s
     * @param ownProps
     */
    MaryInitializerComp.mapStateToProps = function (s, _ownProps) {
        return {
            linked: !!s.prop("mary"),
        };
    };
    /**
     *
     * @param dispatch
     */
    MaryInitializerComp.mapDispatchToProps = function (dispatch) {
        return {
            dispatch: dispatch,
        };
    };
    /**
     * componentDidMount will trigger the redux action to link the mary
     * providers into the redux store.
     */
    MaryInitializerComp.prototype.componentDidMount = function () {
        ensure(this.props.dispatch)(maryInit(__assign({}, this.props)));
    };
    /**
     * componentDidUpdate is responsible for keeping the redux state in sync
     * with the state from the providers.
     */
    MaryInitializerComp.prototype.componentDidUpdate = function () {
        ensure(this.props.dispatch)(maryUpdate(__assign({}, this.props)));
    };
    /**
     * componentWillUnmount will trigger the redux action to un-link the Mary
     * providers.
     */
    MaryInitializerComp.prototype.componentWillUnmount = function () {
        ensure(this.props.dispatch)(maryUnlink());
    };
    /**
     *
     */
    MaryInitializerComp.prototype.render = function () {
        return !this.props.linked
            ? null
            : this.props.children;
    };
    return MaryInitializerComp;
}(React.Component));
/**
 *
 */
var MaryInitializer = connect(MaryInitializerComp.mapStateToProps, MaryInitializerComp.mapDispatchToProps)(MaryInitializerComp);
/**
 *
 * @param s
 */
export var maryOf = function (s) {
    var m = s.prop("mary");
    return ensure(m);
};
